<template>
  <v-container fill-height>
    <v-img
      :src="require('../assets/background-world-map.svg')"
      transition="scale-transition"
    >
      <v-container fill-height fluid>
        <v-row class="text-center">
          <v-col cols="12">
            <v-img
              :src="require('../assets/logo-travel.svg')"
              class="ml-3 my-3"
              contain
              height="100"
              transition="slide-x-transition"
            />
          </v-col>

          <v-col>
            <h1 class="text-h3 font-weight-medium mb-3">
              Bienvenue sur Hermes
            </h1>

            <p class="text-subtitle-1 font-weight-medium">
              La plateforme de mobilité de la HEPH - Condorcet
            </p>

            <p class="text-subtitle-1 font-weight-medium">
              <span class="red--text grey lighten-4">
                Cette plateforme n’est plus utilisée.
                Merci de vous rendre sur la
                <a href="https://hermes.condorcet.be/" target="_blank">nouvelle plateforme</a>
                pour toute demande.
              </span>
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-img>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
};
</script>
